import { useIntl } from '@/intl'
import { useState } from 'react'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    cancelButtonTitle: translate({ id: 'global.cancel' }),
    confirmButtonTitle: translate({ id: 'global.delete' }),
    title: (count: number) =>
      translate({
        id: 'setup.vehicleAssignments.delete.title',
        values: { count },
      }),
    body: (count: number) =>
      translate({
        id: 'setup.vehicleAssignments.delete.body',
        values: { count },
      }),
  }))

  return api
}
